import React, {useEffect, useState} from "react";
import { Link } from "react-router-dom";
import "./Navbar.scss";
import ThemeToggle from "../ThemeToggle/ThemeToggle";
import tldrBlogsLogoTrans from "../../assets/images/tldrBlogsLogoTrans.webp";

const Navbar = (props) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isVisible, setIsVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      if (currentScrollY > lastScrollY && currentScrollY > 50) {
        setIsVisible(false);
      } else {
        setIsVisible(true);
      }
      setLastScrollY(currentScrollY);
      if (window.scrollY >= window.innerHeight) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [lastScrollY]);

  const navPaths = [
    {
      path: "/about",
      title: "ABOUT"
    },
    {
      path: "/blogs",
      title: "BLOGS"
    },
    {
      path: "/contact-us",
      title: "CONTACT US"
    },
  ]
  return (
    <nav className={`navbar ${isScrolled ? "scrolled" : ""} ${isVisible ? "visible" : "hidden"}`}>
      <div className="col1 navbar-links">
      { navPaths.map((navPath) => {
        return (
          <Link to={navPath.path} className="navbar-link">
          {navPath.title}
        </Link>
        )
      })}
      </div>
      <div className="col2 webTitle">
        <Link to="/">
          <img src={tldrBlogsLogoTrans} alt={"tldrWorks"} />
        </Link>
      </div>
      <div className="col3">
        {/* <button className="iconButton">
          <FaSearch size={22} color="#fff" />
        </button> */}

        {/* <ThemeToggle theme={props.theme} toggleTheme={props.toggleTheme} /> */}
      </div>
    </nav>
  );
};

export default Navbar;
